import React from "react";
import {Fade} from "react-reveal";




let Player = () => {
    return(
        <>
            <div className="container mb-5">
                <div className="row">
                    <Fade left></Fade>
                    <Fade left></Fade>
                </div>
            </div>

            
        </>
    );
}
export default Player;